import React, { Component, } from 'react';
import { Row, Col, Button } from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Grammarly, GrammarlyEditorPlugin } from '@grammarly/editor-sdk-react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import optionValues from '../../../../../core/utils/values';


import Icon from '../../../../../elements/Icon';
import GridviewSection from './GridviewSection';

// import useWindowDimensions from '../../../../../core/utils/useWindowDimensions';
import * as customerActions from '../../../../../core/customer/customerActions';

class CustomerNotes extends Component {
    constructor(props) {
        super(props);

        this.state = {
            text: '',
            id: '',
        };
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps, prevState) {
        const { isCreatingUpdatingCustomerNote, error } = this.props;

        if (isCreatingUpdatingCustomerNote === false &&
            prevProps.isCreatingUpdatingCustomerNote === true &&
            error === null
        ) {
            this.setState({ text: '', id: '' });
        }
    }

    componentWillUnmount() {
        this.setState({
            text: '',
            id: '',
        });

        const { actions } = this.props;
        if (actions && actions.resetCustomerNotes) {
            actions.resetCustomerNotes();
        }
    }

    customerInactive() {
        return this.props.customer?.is_active === 0;
    }

    handleSubmit() {
        const { actions, customer } = this.props;

        const addNotes = {
            text: this.state.text,
            customerId: customer?.id,
            noteId: this?.state?.id || ''
        };
        actions.createupdateCustomerNoteRequest(addNotes);
    }

    updateTextEditor(noteData) {
        this.setState({ text: noteData?.text, id: noteData?.id });
    }

    render() {
        const { isCreatingUpdatingCustomerNote } = this.props;

        return (
            <div className="section" style={{ overflowY: 'scroll', height: '100%' }}>
                <div className="section">
                    <div className="container">
                        <Row type="flex" justify="center">
                            <Col span={24} md={20} lg={17}>
                                <div className="section__container">
                                    <div className="section__header">
                                        <h3 className="h-4">Create Customer Note</h3>
                                    </div>
                                    <div className="section-white">
                                        <div className="ant-row-flex ant-row-flex-center">
                                            <div className="ant-col ant-col-18">
                                                <div>
                                                    <div className="">
                                                        <div className="ant-row ant-form-item pb-4">
                                                            <div className="ant-col ant-form-item-label">
                                                                <label className="" title="Text" htmlFor="customer_note_text">Text</label>
                                                            </div>
                                                            <div className="ant-col ant-form-item-control-wrapper">
                                                                <div className="ant-form-item-control">
                                                                    <span className="ant-form-item-children">
                                                                        <div className="">
                                                                            <Grammarly clientId={optionValues.GRAMMARLY_CLIENT_ID}>
                                                                                <GrammarlyEditorPlugin >
                                                                                    <div style={{ height: '250px' }}>
                                                                                        <ReactQuill
                                                                                            readOnly={this.customerInactive()}
                                                                                            theme="snow"
                                                                                            value={this.state.text}
                                                                                            onChange={(val) => { this.setState({ text: val }); }}
                                                                                            modules={{
                                                                                                toolbar: [
                                                                                                    [{ header: [1, 2, 3, 4, 5, false] }],
                                                                                                    [{ font: [] }],
                                                                                                    ['bold', 'italic', 'underline', 'strike'],
                                                                                                    [{ list: 'ordered' }, { list: 'bullet' }],
                                                                                                    ['link'],
                                                                                                    [{ color: [] }, { background: [] }],
                                                                                                    [{ align: [] }],
                                                                                                ],
                                                                                            }}
                                                                                            style={{
                                                                                                height: '100%',
                                                                                                display: 'flex',
                                                                                                flexDirection: 'column',
                                                                                            }} />
                                                                                    </div>
                                                                                </GrammarlyEditorPlugin>
                                                                            </Grammarly>
                                                                        </div>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <Button
                                                loading={isCreatingUpdatingCustomerNote}
                                                disabled={this.state.text === '' || !this.state.text || isCreatingUpdatingCustomerNote || this.customerInactive()}
                                                onClick={() => this.handleSubmit()}
                                                type="primary"
                                                className="average m-0"
                                                htmlType="button">
                                                <Icon name="save" />Submit
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                                <GridviewSection
                                    activeTab={3}
                                    editNoteCallback={(editNote) => this.updateTextEditor(editNote)} />
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        );
    }
}

CustomerNotes.defaultProps = {
    isCreatingUpdatingCustomerNote: false,
    actions: {},
    error: null,
};

CustomerNotes.propTypes = {
    isCreatingUpdatingCustomerNote: PropTypes.bool,
    actions: PropTypes.object,
    customer: PropTypes.object.isRequired,
    error: PropTypes.object,
};

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        customer: state.customer.customer,
        isCreatingUpdatingCustomerNote: state.customer.isCreatingUpdatingCustomerNote,
        error: state.customer.error || null,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...customerActions,
        }, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerNotes);
